import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"

export const ManifestoContainer = styled.section`
  .special-br {
    @media (min-width: 480px) and (max-width: 767px) {
      display: block;
    }
  }
`

export const ItemFlex = styled(Flex)`
  gap: 24px;
`

export const RightBox = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;

  &.include-link {
    align-items: flex-start;
    justify-content: space-between;
    min-height: 82px;
    flex-direction: column;
    padding-left: 16px;

    ${queries.large`
      min-height: 102px;
    `}

    ${queries.xxLarge`
      justify-content: flex-end;
    `}
  }

  .button-wrapper {
    button,
    &:hover {
      border-color: ${theme.wild.color.nova.brand.accent[80]};
      span,
      span:hover {
        color: ${theme.wild.color.nova.brand.accent[80]};
        svg {
          path {
            fill: ${theme.wild.color.nova.brand.accent[80]} !important;
          }
        }
      }
    }
  }
`
